export default __webpack_public_path__ + "static/media/help4.0741a8d7.svg";